var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'menu-item': true, 'active': _vm.active, ..._vm.classes },on:{"click":_vm.select}},[_c('img',{attrs:{"src":_vm.icon}}),_c('label',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }